export default "__VITE_ASSET__ChZJ$phI__"